import React from 'react';
import _ from 'lodash';

export default function StyledSelectComp (props){
    return (
        <div className='select-wrapper'>
            <select {..._.omit(props, 'children')}>
                {props.children}
            </select>
        </div>
    );
}
